import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth-slice";
import customersReducer from "./customers-slice";
import uiReducer from "./ui-slice";
import hardwaresReducer from "./hardware-slice";
import licensesReducer from "./licenses-slice";
import usersReducer from "./users-slice";
import { setToken } from "../services/api";

const saveAuthToken = (store) => (next) => (action) => {
  if (action && action.type === "authUser/login") {
    console.log("Setting auth token for api calls");
    setToken(action.payload.token);
  }

  return next(action);
};

const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    customers: customersReducer,
    hardwares: hardwaresReducer,
    licenses: licensesReducer,
    users: usersReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(saveAuthToken),
});

export default store;
